import loadDomainReduxAction from '../../../../redux/actions/load'
import { getDomainListPathWorkoutsSelect } from '../../../../workouts-ui/selectors/get-domain-list-path'
import WORKOUTS_ACTION from '../../constants/action'
import WORKOUTS_ENDPOINT from '../../constants/endpoint'
import WORKOUTS_PATH from '../../constants/path'
import { logUtil } from 'packages/src'

function loadWorkoutsAction (params = {}) {
  return async (dispatch, getState) => {
    try {
      const domainListPath = (
        params.domainListPath || getDomainListPathWorkoutsSelect(
          getState(),
          params.query?.isLogged
            ? WORKOUTS_PATH.LOGGED
            : WORKOUTS_PATH.NON_LOGGED_AND_PLANNED
        )
      )

      await dispatch(loadDomainReduxAction({
        type: WORKOUTS_ACTION.LOAD,
        payload: {
          ...params,
          domainListPath,
          endpoint: WORKOUTS_ENDPOINT.WORKOUTS
        }
      }))
    } catch (error) {
      logUtil('').warn('loading workouts failed: ', error)
    }
  }
}

export default loadWorkoutsAction
